// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/components/home/home.component.less
// module id = 484
// module chunks = 0